import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import { Link } from "react-router-dom";
const Body = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { P_getPrint } = value;

          return (
            <html dir="rtl">
              <div className="row PR mr-5">
                <Link to="/text-print">
                  <button
                    onClick={P_getPrint}
                    type="button"
                    className="btn btn-info mr1"
                    style={{
                      backgroundColor: "#9900ff",
                      border: "1px solid #9900ff"
                    }}
                  >
                    <i className=" fas fa-print fa-lg white "></i>
                  </button>
                </Link>
              </div>
            </html>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default Body;
